export enum CookieKeyEnum {
  COOKIE_PREFERENCE = 'cookie_preference',
  GOOGLE_ANALYTICS_CONSENT_GRANTED = 'google_analytics_consent_granted',
}
